// import { useWaterMark } from "../../Components/WaterMark/WatermarkProvider";

// const WaterMark = () => {
//   const { ip, currentDateTime } = useWaterMark();

//   return (
//     <>
//       <div className="absolute inset-0 flex items-center justify-center pointer-events-none opacity-50 z-[1]">
//         <div className="p-8 text-slate-300 flex flex-col items-center">
//           <p>{localStorage.getItem("username")}</p>
//           <p>{ip}</p>
//           <p className="whitespace-nowrap">{currentDateTime}</p>
//         </div>
//       </div>
//     </>
//   );
// };

// export default WaterMark;

import { useWaterMark } from "../../Components/WaterMark/WatermarkProvider";

const WaterMark = () => {
  const { ip, currentDateTime } = useWaterMark();

  // Get username from sessionStorage instead of localStorage
  const username = localStorage.getItem("username") || "Guest";

  return (
    <div className="absolute inset-0 flex items-center justify-center pointer-events-none opacity-50 z-[1]">
      <div className="p-8 text-slate-300 flex flex-col items-center">
        <p>{username}</p>
        <p>{ip}</p>
        <p className="whitespace-nowrap">{currentDateTime}</p>
      </div>
    </div>
  );
};

export default WaterMark;
